import { createContext, ReactNode, useContext, useMemo, useState } from 'react';
import { useLocalStorage } from 'usehooks-ts';

const PRESIGNUP_TEXT_STORAGE_KEY = 'presignupText';

type PreSignUpText = { text: string; title: string };

const landingContext = createContext<{
  preSignUpText?: PreSignUpText;
  setPreSignUpText: (preSignUpText?: PreSignUpText) => void;
  surveyResponseId?: string;
  setSurveyResponseId: (id?: string) => void;
}>({
  preSignUpText: undefined,
  setPreSignUpText: () => undefined,
  setSurveyResponseId: () => undefined,
  surveyResponseId: undefined,
});

const LandingContext = ({ children }: { readonly children: ReactNode }) => {
  const [surveyResponseId, setSurveyResponseId] = useState<string | undefined>();
  const [preSignUpText, setPreSignUpText] = useLocalStorage<PreSignUpText | undefined>(
    PRESIGNUP_TEXT_STORAGE_KEY,
    undefined
  );

  const contextValue = useMemo(
    () => ({
      preSignUpText,
      setPreSignUpText,
      setSurveyResponseId,
      surveyResponseId,
    }),
    [surveyResponseId, setSurveyResponseId, preSignUpText, setPreSignUpText]
  );

  return <landingContext.Provider value={contextValue}>{children}</landingContext.Provider>;
};

const useLandingContext = () => useContext(landingContext);

export { LandingContext, useLandingContext };
